import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Overseeing Waste Management System" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Overseeing Waste Management System</h3>
                                <p className='caboutus c-lineheight2dot5'>Different types of wastes are being generated within the IIT Tirupati campus due to various activities. The wastes could be Solid waste (dry or wet), Chemical wastes, e-waste, debris wastes from labs and other miscellaneous wastes etc. which are coming from residential zone, academic zone, hostel zone including dining hall(s), canteens etc. As an institute it should be ensured a system to handle proper collection of these wastes and appropriate treatment /safe disposal.</p>

                                <p className='caboutus c-lineheight2dot5'>A committee is constituted for Overseeing the Waste Management System with the following members:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. B. Janaki Ramaiah</p>
                                                <p>Chairperson - Engineering Unit </p>
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Narasamma Nippatlapalli</p>
                                                <p>Assistant Professor - Department of Civil & Environmental Engineering
                                               
                                                </p>
                                            </td>
                                            <td> Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. M. Suneel Kumar</p>
                                                <p>Technical Officer - Department of Civil & Environmental Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. P Vamshi Seshasayan</p>
                                                <p>Technical Officer - Computer Center</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. M. Jagadeesh</p>
                                                <p>Technical Superintendent - Department of Chemistry </p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. M Venkata Ramana</p>
                                                <p>Assistant Registrar - Student Affairs</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. G Venkata Subba Reddy</p>
                                                <p>Horticulture officer - Engineering Unit</p>
                                            </td>
                                            <td>Convenor</td>
                                        </tr>

                                        
                                    </tbody>

                                </Table>

                               


                                <p className=' fw-bold c-headline caboutus mt-3 mb-3'>The roles and responsibilities of the committee include:</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Review various operations/activities in the institute to evaluate the quantum of different types of wastes being generated.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Evolve proper waste collection system through separated bins for different types of wastes.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Prepare an advisory manual or instructions and display boards at appropriate place for the benefit of various users to implementing proper waste segregation and collection.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Develop a scheme of operations for smooth waste collection, treatment and safe disposal as per the norms ensuring the environment concerns.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Any other as relevant to the objective of proper waste management system.</li>
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;